import { z } from "zod";

export const addendumSchema = z.object({
  addendum: z.string().min(1, "Comment is required."),
});

export type AddendumFormValues = z.infer<typeof addendumSchema>;
